import * as React from "react";

function SvgReordersOutlined(props) {
  return <svg viewBox="0 0 38 40" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M29.417.167l-6.25 6.25 6.25 6.25V8.5h4.166v27.083H25.25v4.167h8.333c2.278 0 4.167-1.89 4.167-4.167V8.5c0-2.277-1.89-4.167-4.167-4.167h-4.166V.167zM.25 4.333V8.5h20.833V4.333H.25zm0 8.334v10.416h20.833V12.667H.25zm4.167 4.166h12.5v2.084h-12.5v-2.084zM.25 27.25v12.5h20.833v-12.5H.25zm4.167 4.167h12.5v4.166h-12.5v-4.166z" /></svg>;
}

export default SvgReordersOutlined;